import gql from 'graphql-tag';

const GET_EXHIBITORS = gql`
    query exhibitors($filter: String) {
      exhibitors(filter: $filter) {
        items {
          id
          tradeName
          companyName
          booth
        }
      }
    }
`
;

export default GET_EXHIBITORS;



/** WEBPACK FOOTER **
 ** ./src/graphql/GET_EXHIBITORS.js
 **/